import React from "react";
import { useLang } from "@/context/LanguageContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe, Check } from "lucide-react";

export const LanguageSwitcher = ({ dark = false }) => {
  const { lang, changeLang, languages } = useLang();
  const current = languages.find((l) => l.code === lang);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="lang-switcher"
        className={`flex items-center gap-1.5 text-sm font-medium tracking-wide outline-none transition-colors ${
          dark ? "text-ink hover:text-brass" : "text-white/90 hover:text-brass"
        }`}
      >
        <Globe className="w-4 h-4" />
        {current?.label}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[9rem] rounded-none border-brass/30">
        {languages.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => changeLang(l.code)}
            className="flex items-center justify-between cursor-pointer text-sm"
          >
            <span>{l.name}</span>
            {l.code === lang && <Check className="w-3.5 h-3.5 text-brass" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
